import React from 'react';
import wrapStore from '@src/utils/wrap-store';
import FiveSectionStore from '@src/pages/main/sections/five-section/store';
import cx from 'classnames';
const styles = require('./index.less');

/**
 * FiveSection
 * @param store {FiveSectionStore}
 * @returns {JSX.Element}
 * @constructor
 */
const FiveSection = ({ store }) => {
  store.use();
  // console.log(store.coordinateList);

  return (
    <div className={styles.fiveSectionRoot}>
      <div className={styles.bg}>
        {/* <div className={styles.decorate_text} data-name="空投展示" /> */}
        <div className={styles.top_bg} />
        <div className={styles.bottom_bg} />

        <div className={cx('frame', styles.frame)}>
          {store.coordinateList.map((item, key) => {
            return <div key={key} className={cx('onMeng', 'on' + (key + 1), store.active === key && 'onMengShow')} />;
          })}

          <div className={styles.coordinate}>
            {store.coordinateList.map((item, index) => {
              return (
                <div key={index} className={cx('slick', 'slick' + (index + 1))}>
                  <div
                    className={cx('title', 'title' + index, index === store.active && styles.tilte_active)}
                    onMouseEnter={e => store.switchCoordinate(e, index)}
                  />
                  {index === store.active && <div className={styles.circle} style={{ backgroundImage: `url(${item.imgCenter})` }} />}
                  {index === store.active && (
                    <div className={styles.centerText}>
                      <div className={styles.centerText_item1}>{item.id}</div>
                      <div className={styles.centerText_item2}>{item.text}</div>
                    </div>
                  )}
                </div>
              );
            })}
            <div className={styles.bottomMask} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default wrapStore(FiveSection, FiveSectionStore);
